import { render, staticRenderFns } from "./PRO_ByProject.vue?vue&type=template&id=61c87352&scoped=true&"
import script from "./PRO_ByProject.vue?vue&type=script&lang=js&"
export * from "./PRO_ByProject.vue?vue&type=script&lang=js&"
import style0 from "./PRO_ByProject.vue?vue&type=style&index=0&id=61c87352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c87352",
  null
  
)

export default component.exports